import { ModalFactory } from '@/utils/modal-util';

export interface ModalState<T> {
	isOpen: boolean;
	props: T;
}

export interface JupiterMessageModalData {
	title: string;
	message: string;
	eventKey?: string;
}

export interface NickNameModal {
	isRewardPage: boolean;
	isOpen: boolean;
}

export interface BettingPreferenceModal {
	isShow: boolean;
	isFirstTime: boolean;
}

const modalFactory = new ModalFactory();

const loginModal = modalFactory.createModal<boolean>('login');
const messageModal = modalFactory.createModal<string>('message');
const depositNowModal = modalFactory.createModal<boolean>('depositNow');
const jupiterMessageModal = modalFactory.createModal<ModalState<JupiterMessageModalData>>('jupiterMessage');
const jupiterLogoutMessageModal = modalFactory.createModal<ModalState<JupiterMessageModalData>>('jupiterLogoutMessage');
const newbieTutorialModal = modalFactory.createModal<boolean>('newbieTutorial');
const bankInfoAlertModal = modalFactory.createModal<boolean>('bankInfoAlert');
const goldenDuelToolTipModal = modalFactory.createModal<boolean>('goldenDuelToolTip');
const nickNameModal = modalFactory.createModal<NickNameModal>('nickName');
const bettingPreferenceModal = modalFactory.createModal<BettingPreferenceModal>('bettingPreference');

export const modalService = {
	onOpenLoginModel: loginModal.observable,
	onOpenDepositNowModal: depositNowModal.observable,
	onOpenMessageModal: messageModal.observable,
	onOpenJupiterMessageModal: jupiterMessageModal.observable,
	onOpenJupiterLogoutMessageModal: jupiterLogoutMessageModal.observable,
	onOpenNewbieTutorialModal: newbieTutorialModal.observable,
	onOpenNickNameModal: nickNameModal.observable,
	onOpenBankInfoAlertModal: bankInfoAlertModal.observable,
	onOpenGoldenDuelToolTipModal: goldenDuelToolTipModal.observable,
	onOpenBettingPreferenceModal: bettingPreferenceModal.observable,

	openLoginModal: () => loginModal.set(true),
	openMessageModal: (message: string) => messageModal.set(message),
	openDepositNowModal: () => depositNowModal.set(true),
	openJupiterMessageModal: (props: JupiterMessageModalData) => 
		jupiterMessageModal.set({ isOpen: true, props }),
	closeJupiterMessageModal: (eventKey: string) => 
		jupiterMessageModal.set({ isOpen: false, props: { title: '', message: '', eventKey } }),
	openJupiterLogoutMessageModal: (props: JupiterMessageModalData) => 
		jupiterLogoutMessageModal.set({ isOpen: true, props }),
	closeJupiterLogoutMessageModal: () => 
		jupiterLogoutMessageModal.set({ isOpen: false, props: { title: '', message: '', eventKey: 'JupiterLogout' } }),
	openNewbieTutorialModal: () => newbieTutorialModal.set(true),
	openNickNameModal: (isRewardPage: boolean, isOpen: boolean) => 
		nickNameModal.set({ isRewardPage, isOpen }),
	openBankInfoAlertModal: (isOpen: boolean) => bankInfoAlertModal.set(isOpen),
	openGoldenDuelToolTipModal: (isOpen: boolean) => goldenDuelToolTipModal.set(isOpen),
	displayBettingPreferenceModal: (isShow: boolean, isFirstTime: boolean = false) => 
		bettingPreferenceModal.set({ isShow, isFirstTime }),
};
